/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 djjjj.glb 
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Djjjj(props) {
  const { nodes, materials } = useGLTF('/media/models/djjjj.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.dj.geometry} material={materials.Material_0} />
    </group>
  )
}

useGLTF.preload('/media/models/djjjj.glb')
